import { render, staticRenderFns } from "./ClaimExpense.vue?vue&type=template&id=4090310a"
import script from "./ClaimExpense.vue?vue&type=script&lang=js"
export * from "./ClaimExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports